console.log('init_prediction_games.js loaded!');

/* css for the specific page */
import "./pages-assets/games/prediction-games/prediction-games.css";


   

/* scripts for the specific page */
import "./pages-assets/games/prediction-games/prediction-games.js";
